import ExamView from "../../NewComponents/Views/ScoreViews/ExamView";

interface ExamListCardProps {
	className?: string;
	rows: { id: string }[];
}

function ExamListCard({ className, rows }: ExamListCardProps) {
	return (
		<div className={className}>
			{rows.map((row) => (
				<ExamView className="mb-8" key={row.id} row={row} />
			))}
		</div>
	);
}

export default ExamListCard;
